import { render, staticRenderFns } from "./ReviewCategoryFilter.vue?vue&type=template&id=27c06276"
import script from "./ReviewCategoryFilter.vue?vue&type=script&lang=js"
export * from "./ReviewCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports